import React from 'react';
import GlobalStyles from './src/components/GlobalStyles';

export const wrapPageElement = ({ element, props }) => (
  <>
    <GlobalStyles />
    {element}
  </>
);
